<template>
  <div class="support">
    <!-- Hero Section -->
    <section class="hero">
      <div class="container">
        <h1>全心全意   真诚服务</h1>
        <p>专注物联网技术创新，助力产业升级</p>
      </div>
    </section>
    <!-- 常见问题 -->
    <section class="faqs">
      <div class="container">
        <h2 class="section-title">常见问题</h2>
        <el-collapse accordion class="faqs-collapse">
          <!-- 循环渲染 FAQ 项 -->
          <el-collapse-item 
            v-for="(item, index) in faqsList" 
            :key="index" 
            :title="item.question"
          >
            <div class="faqs-content">{{ item.answer }}</div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </section>
    <section class="card">
      <div class="container">
        <h2 class="section-title">流量卡查询</h2>
        <div class="mobile-preview-container">
          <div class="mobile-device">
            <!-- 模拟手机顶部的听筒和摄像头 -->
            <div class="mobile-top">
              <div class="earpiece"></div>
              <div class="camera"></div>
            </div>
            <div class="mobile-screen">
              <!-- iframe 嵌入页面 -->
              <iframe
                class="mobile-iframe"
                src="https://iot.juzi1688.cn/dist/#/loop" 
                allow="camera; microphone"
                frameborder="0"
                scrolling="auto"
              ></iframe>
            </div>
            <!-- 模拟手机底部的按键 -->
            <div class="mobile-bottom">
              <div class="home-button"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Support',
  data() {
    return {
      cultures: [
        {
          icon: 'el-icon-aim',
          title: '企业使命',
          description: '用科技创新推动产业升级，让物联网技术惠及更多领域'
        },
        {
          icon: 'el-icon-view',
          title: '企业愿景',
          description: '成为物联网行业的领军企业，引领行业发展方向'
        },
        {
          icon: 'el-icon-star-on',
          title: '核心价值观',
          description: '创新、诚信、协作、共赢'
        },
        {
          icon: 'el-icon-trophy',
          title: '企业精神',
          description: '追求卓越，永不止步'
        }
      ],
      faqsList: [
        {
          question: '物联网卡售后问题找谁？',
          answer: '物联网卡所有售后问题只能由你所购买的该卡运营服务商才能解决，如果你不是从物联网卡服务商直接购买的，收到设备后请关注物联网卡外包装上的“万物互联公众号”，有任何问题欢迎咨询！'
        },
        {
          question: '物联网卡更换到其它设备使用是否会锁卡？',
          answer: '由于物联网卡流量资费比较便宜，为避免有些用户将专用物联网卡挪做它用，一般物联网卡都会做机卡绑定。如果是智能设备故障原因更换导致锁卡的，向物联网卡服务商联系可以远程解锁。'
        },
        {
          question: '物联网卡会限速吗？',
          answer: '移动通信技术从2G不断更新迭代至5G，其目的就是不断提高数据传输速率，实现物联网设备高效工作。正规的物联卡平台服务商是绝对不会在自己管理平台上给用户限速的。只有那些打着“在套餐有效期内不限流量、不限时随意使用“当时觉得超低价的物联网卡，如果你流量提前快用完了，一定会给你限速，甚至时不时断网，让你没法用。'
        },
        {
          question: '购买物联卡时要注意什么？', 
          answer:'务必咨询清楚物联网卡的流量虚实、是否实名、是否需要设置APN、是否限速、是否会锁设备等问题！'
        },
        {
          question: '购买物联网卡激活是否需要实名认证？',
          answer:'根据工信部和三大运营商的要求，企业和集团用户采购时需将所用的卡号实名在企业和集团名下，具体每张物联网卡不会实名。如果个人购买，目前还没有强制要求实名认证。'
        },
        {
          question:'物联网设备数据传输不稳定是什么原因？',
          answer:'首先确认下你的物联网设备安装的位置与所购买的物联网卡运营商的信号强弱，如果该网络信号太弱就无法正常使用，请与物联卡服务商联系更换成你要求的运营商物联网卡。在此，特别提醒用户在购买出厂已配套物联网卡的智能设备时，先要确认设备使用的网络环境，以免给你带来不便。'
        },
        {
          question:'物联网卡的流量会虚吗？',
          answer:'正规的物联卡平台服务商会严格按照用户购买的套餐流量设置阈值，如果智能终端在累计使用流量接近阈值仍在线，一般会超限使用部分流量，因为流量管理平台断网有时延的现象。故从正规物联网卡平台服务商购买的物联卡流量是绝对不会虚的，甚至用户会多用部分流量。相反市面上打着“在套餐有效期内不限流量、不限时、不限速”随意使用的物联网卡都是骗局。因为流量是运营商的商品，凡是商品就有成本，如果你提前把流量用完了还给你正常用，多出的费用哪个商家会自掏腰包给运营商呢？'
        },
        {
          question:'物联网卡能长期正常使用的前提条件是什么？',
          answer:'每月必须按时提前缴费、尤其是能使用语音和短信功能的物联网卡，除缴足流量费外还要缴清其它通讯费用，因为流量套餐费仅限设备上网费用。'
        }
      ]
      
    }
  },
  methods: {
    
  }
}
</script>

<style lang="scss" scoped>
.support {
  .hero {
    background: linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url('../assets/images/support.jpg');
    background-size: cover;
    background-position: center;
    height: 400px;
    display: flex;
    align-items: center;
    color: #fff;
    text-align: center;
    
    .container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 20px;
      
      h1 {
        font-size: 48px;
        margin-bottom: 20px;
      }
      
      p {
        font-size: 24px;
      }
    }
  }
  
  .section-title {
    text-align: center;
    font-size: 36px;
    margin-bottom: 50px;
    color: #2c3e50;
  }
  
  
  
  .company-culture {
    padding: 20px 0;
    background: #f8f9fa;
    
    .culture-card {
      height: 168px;
      text-align: center;
      padding: 30px;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
      margin-bottom: 30px;
      
      i {
        font-size: 48px;
        color: #409EFF;
        margin-bottom: 20px;
      }
      
      h3 {
        font-size: 20px;
        margin-bottom: 15px;
        color: #2c3e50;
      }
      
      p {
        color: #666;
        line-height: 1.6;
      }
    }
  }

  .faqs {
    padding: 40px 0;
    .container{
      padding: 20px;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 2px 12px rgba(0,0,0,0.05);
    }
    .faqs-collapse {
    // 折叠项标题
      ::v-deep .el-collapse-item__header {
        font-size: 20px;
        color: #444;
        padding: 10px 20px;
        background: #f8f9fa;
        // border: 1px solid #ebeef5;
        border-radius: 4px;
        transition: all 0.3s;

        &:hover {
          background: #f1f3f7;
        }
      }

    // 激活状态标题
      ::v-deep .el-collapse-item.is-active .el-collapse-item__header {
        background: #e7f1ff;
        color: #409eff;
        border-color: #c6e2ff;
      }

      // 内容区域
      ::v-deep .el-collapse-item__content {
        padding: 10px 20px;
        color: #666;
        background: #fff;
        border: 1px solid #ebeef5;
        border-top: none;
        border-radius: 0 0 4px 4px;
        line-height: 1.6;
        font-size: 1rem;
      }
    }
    
  }

  .card{
     padding: 40px 0;
    .mobile-preview-container{
      display: flex;
      justify-content: center;
      padding: 40px 0;
    }
    .mobile-device {
      // 调整为接近常见手机屏幕的尺寸
      width: 375px; 
      height: 812px; 
      border: 16px solid #1a1a1a;
      border-radius: 48px;
      // background: #000;
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3), 0 0 0 2px #000;
      position: relative;
      // 调整手机模拟设备的外边距
      margin: 20px 0;

      .mobile-top {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 60%;
        height: 30px;
        // background: #000;
        border-bottom-left-radius: 15px;
        border-bottom-right-radius: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;

        .earpiece {
          width: 40%;
          height: 4px;
          background: #1a1a1a;
          border-radius: 2px;
        }

        .camera {
          width: 12px;
          height: 12px;
          background: #1a1a1a;
          border-radius: 50%;
        }
      }
      .mobile-screen {
        position: relative;
        width: 100%;
        height: calc(100% - 80px); /* 减去上下黑边 */
        overflow: hidden;

        .mobile-iframe {
          width: 100%;
          height: 100%;
          border: none;
        }
      }
      .mobile-bottom {
        position: absolute;
        bottom: 10px;
        left: 50%;
        transform: translateX(-50%);
        width: 50px;
        height: 50px;
        border: 2px solid #1a1a1a;
        border-radius: 50%;
      }
    }
  }
  
  .team {
    padding: 80px 0;
    background: #f8f9fa;
    
    .team-card {
      background: #fff;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
      margin-bottom: 30px;
      
      .member-avatar {
        height: 200px;
        overflow: hidden;
        
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      
      .member-info {
        padding: 20px;
        text-align: center;
        
        h3 {
          font-size: 20px;
          margin-bottom: 5px;
          color: #2c3e50;
        }
        
        .position {
          color: #409EFF;
          margin-bottom: 10px;
        }
        
        .description {
          color: #666;
          line-height: 1.6;
        }
      }
    }
  }
  
  .contact {
    padding: 80px 0;
    
    .contact-info {
      h3 {
        font-size: 24px;
        margin-bottom: 20px;
        color: #2c3e50;
      }
      
      p {
        color: #666;
        margin-bottom: 15px;
        display: flex;
        align-items: center;
        
        i {
          margin-right: 10px;
          color: #409EFF;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .about {
    .hero {
      height: 300px;
      
      .container {
        h1 {
          font-size: 32px;
        }
        
        p {
          font-size: 18px;
        }
      }
    }
    
  }
}</style> 